<div class="row" style="margin-top: 10px;">
  <div class="col-md-3" *ngFor="let roommate of backendService.roommates">
    <div *ngIf="roommate.laundryActive && roommate.laundryDryer || roommate.laundryWash" class="alert alert-info text-center" style="font-size: 10px;">
      {{roommate.name}} is using the <span [innerText]="laundryStatement(roommate)"></span>
    </div>
  </div>
</div>
